'use strict';

import angular from 'angular';
import ForgotPasswordController from './forgotpassword.controller.js';

export default angular.module('georgeApp.forgotpassword', [])
  .controller('ForgotPasswordController', ForgotPasswordController)
  .name;
